import React, { forwardRef } from "react";
import { 
    Typography,
    IconButton
} from '@material-ui/core';
import MediaLibrary from '../../../components/MediaLibrary/';
import { KeyboardBackspace } from 'mdi-material-ui';
import { NavLink } from 'react-router-dom';
const ForwardNavLink = forwardRef((props, ref) => (
    <NavLink {...props} innerRef={ref} />
))

const Layout = (props) => {
    return (
        <>  
            <div className="d-flex align-items-center mb-3">
                <IconButton size="small" className="me-1" component={ForwardNavLink} to={"/dashboard/listings"}>
                    <KeyboardBackspace/>
                </IconButton>
                <Typography variant="h6" className="mb-0">Manage Media</Typography>
            </div>
            <MediaLibrary
                property_id={props.match.params.property_id}
            />
        </>
    )
}
export default Layout; 